import axios from 'axios';
import * as types from '@/store/mutation-types';


export interface BraintreeState {
    loading: Record<string, boolean>
}

// state
const state: BraintreeState = {
    loading: {
        analytics: false,
        fetchCart: false,
    },
};

const getters = {
    loading: (state: BraintreeState) => state.loading,
};

const mutations = {
    [types.SET_BRAINTREE_LOADING](state: BraintreeState, loading: { subject: string, loading: boolean }) {
        state.loading[loading.subject] = loading.loading;
    },
};

const actions = {

    async getBraintreeOauthUrl({commit}) {
        commit('SET_BRAINTREE_LOADING', {subject: 'analytics', loading: true});

        try {
            try {
                const response = await axios.get('/v1/braintree/url');
                return response.data;
            } catch (e) {
                console.error('Error fetching Braintree OAuth URL:', e);
            }
        } finally {
            commit('SET_BRAINTREE_LOADING', {subject: 'analytics', loading: false});
        }
    },

    async saveBraintreeCode({commit}, data) {
        commit('SET_BRAINTREE_LOADING', {subject: 'analytics', loading: true});

        return axios.post('/v1/braintree/redirect', data)
            .then((response) => {
                return response.data;
            }).catch((e) => {
                console.error('Error saving Braintree OAuth code:', e);
            }).finally(() => {
                commit('SET_BRAINTREE_LOADING', {subject: 'analytics', loading: false});
            });
    },

    async getBraintreeProvider() {
        try {
            try {
                const response = await axios.get('/v1/braintree/');
                return response.data;
            } catch (e) {
                console.error('Error fetching Braintree provider:', e);
            }
        } finally {
        }
    },
};

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters,
};
